import { AppointmentWrapper } from "@widgets/appointment/ui/appointment-wrapper/appointment-wrapper";
import React from "react";

export const Appointment = () => {
  return (
		<AppointmentWrapper isTeacher/>
  );
};
